import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CdpRouterViewCss } from "@/templates/CdpTemplatesCss";
import { Box } from "@gemini/core";
export const RouteContainer = ({ children }) => (_jsxs(Box, { as: "main", position: "relative", children: [_jsx(CdpRouterViewCss, {}), children] }));
